/**
 * What a mission is drawn with, and the rule behind the tile.
 *
 * Beside `MissionCover.tsx` for the same reason `natoSymbols.ts` is beside
 * `NatoSymbol.tsx`: a file that exports components exports only components, so
 * the dev server can hot-replace them.
 */

/** The choices the platform stores on a mission (`mission.cover`). */
export type Cover = 'AUTO' | 'TERRAIN' | 'TYPE';

/** The three, in the order the picker offers them. */
export const COVERS: Cover[] = ['AUTO', 'TERRAIN', 'TYPE'];

/**
 * A stable hue for a mission type.
 *
 * The point is that a type always looks the same wherever it appears — the
 * library, the home page, a campaign's chapters — so the colour has to come out
 * of the type's own name and nothing else. A small hash over the characters,
 * spread around the wheel; the saturation and the lightness are fixed in the
 * stylesheet's own terms, so no type comes out unreadable or shouting.
 */
export function hueOf(seed: string): number {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) hash = (hash * 31 + seed.charCodeAt(i)) % 360;
  return hash;
}
